export const MY_CHARTS_PAGE_NAME = "My Chart";
export const MY_CHARTS_TABLE_NAME = "All Chart";